import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'xeneta-adds-linescape',
  template: require('./xeneta-adds-linescape.component.html'),
  styles: [require('./../blog.component.scss'), require('./xeneta-adds-linescape.component.scss')]
})
export class XenetaAddsLinescapeComponent extends BlogPage {
  title = "Xeneta Adds Linescape Sailing Schedules - Linescape";
  description = "Norwegian Start-up Integrates Linescape's Schedule Data into Freight Rate Transparency Platform";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/xeneta-adds-linescape/xeneta-adds-linescape.component.ts